import type { Icon } from "@tabler/icons-react";
import {
  IconCloudDownload,
  IconCoinEuro,
  IconFilePower,
  IconSectionSign
} from "@tabler/icons-react";
import type { components } from "../../../../../../types/api.types";

enum CompanyFeatureKeys {
  isErloesmonitoringActive = "isErloesmonitoringActive",
  isParagraph6EegActive = "isParagraph_6EegActive",
  shouldRegulatoryDutiesBeChecked = "shouldRegulatoryDutiesBeChecked",
  isRedispatchImportActive = "isRedispatchImportActive"
}

type CompanyFeature = {
  label: string;
  key: CompanyFeatureKeys;
  icon: Icon;
};

const COMPANY_FEATURES: Array<CompanyFeature> = [
  {
    label: "Stromsteuer",
    key: CompanyFeatureKeys.shouldRegulatoryDutiesBeChecked,
    icon: IconFilePower
  },
  {
    label: "§ 6 EEG",
    key: CompanyFeatureKeys.isParagraph6EegActive,
    icon: IconSectionSign
  },
  {
    label: "Erlösmonitoring",
    key: CompanyFeatureKeys.isErloesmonitoringActive,
    icon: IconCoinEuro
  },
  {
    label: "Redispatch/DVA Import",
    key: CompanyFeatureKeys.isRedispatchImportActive,
    icon: IconCloudDownload
  }
];

export function getCompanyFeatures(company: components["schemas"]["Person"]) {
  return COMPANY_FEATURES.filter((feature) => company[feature.key]);
}
